/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Menu } from '../../models/menu';

export interface ApiMasterMenuGetActiveGet$Params {
}

export function apiMasterMenuGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterMenuGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Menu>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterMenuGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Menu>>;
    })
  );
}

apiMasterMenuGetActiveGet.PATH = '/api/Master/Menu/GetActive';
